import { smsCompatibleSharedKeys } from './sms_compatible_shared_keys'
import { joinInstructionsSettingsFromApi } from './join_instructions_settings_from_api'

export function filterJoinInstructions (urls = []) {
  return urls.filter(url => url.path().split('/')[1] !== 'join_instructions')
}

export function joinInstructionsDefaultSettings (options = {}) {
  return {
    session_keyword: (options?.username || '').toString().toUpperCase(),
    simple_keywords: false,
    shortcode: '',
    sms_enabled: false,
    web_enabled: true,
    stand_alone: true
  }
}

export async function joinInstructionsSettings (options = {}) {
  const activities = filterJoinInstructions(options?.urls || [])
  const smsCompatibleKeys = smsCompatibleSharedKeys(activities || [])
  if (smsCompatibleKeys.length > 0 && smsCompatibleKeys.length === activities.length) {
    try {
      return await joinInstructionsSettingsFromApi(smsCompatibleKeys)
    } catch (error) {
      console.error(error)
      throw new Error('Error communicating with Poll Everywhere to get join instruction settings.')
    }
  }

  return joinInstructionsDefaultSettings({ username: options?.username })
}
